export default __webpack_public_path__ + "static/mvp-hero-fallback-191702b1761054438b6abe37b9dc00a5.jpg";